import React, { useContext, useEffect, useState } from "react";
import {
  CART_STEP,
  PAYMENT_METHOD,
  CartContext,
} from "../../../contexts/CartContext";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import CustomCheckbox from "../../WorkExchange/CustomCheckbox";
import Button from "../../common/Button";
import { formatNumber } from "../../../helpers/common.helper";
import TenderingDetailContext from "../../../pages/TenderingPage/context";

const assetsUri = import.meta.env.ASSETS_URI;

export const Summary = (props) => {
  const { getLang } = useContext(AppContext);
  const {
    paymentTerms,
    paymentStep: step,
    currentQuotation,
    paymentMethod,
    checkout,
    checkingOut,
    cardDetails,
    charging,
    chargeJournal,
  } = useContext(TenderingDetailContext);
  const TranslationShoppingCart = getLang(langComponent.chat);
  const TranslationWorkExchange = getLang(langComponent.workExchange);
  const [includeVat, setIncludeVat] = useState(false);

  const [detail, setDetail] = useState({
    subTotal: 0,
    vat: 0,
    charge: 0,
    wht: 0,
    discounts: 0,
    grandTotal: 0,
  });

  const payments =
    paymentTerms?.reduce((prev, curr) => {
      if (!paymentTerms[0].paid && prev.length === 2) return prev;
      if (paymentTerms[0].paid && prev.length === 1) return prev;

      if (!curr.paid) return prev.concat(curr);

      return prev;
    }, []) ?? [];

  useEffect(() => {
    const subTotal = payments.reduce((prev, curr) => {
      return prev + (curr.total ?? curr.subTotal);
    }, 0);

    const vat = subTotal * 0.07;

    let wht = 0;

    if (currentQuotation.wht < 0) {
      wht = subTotal * 1.07 * 0.03;
    }

    const netTotal = subTotal + vat - wht;

    let charge = 0;

    if (paymentMethod === PAYMENT_METHOD.CARD) {
      charge = (netTotal * 3.65) / 100;
    }

    if (paymentMethod === PAYMENT_METHOD.TRUEMONEY) {
      charge = (netTotal * 2.65) / 100;
    }

    if (paymentMethod === PAYMENT_METHOD.QR) {
      charge = (netTotal * 1.65) / 100;
    }

    const grandTotal = netTotal + charge;

    setDetail({
      subTotal,
      discounts: 0,
      vat,
      charge,
      grandTotal,
      wht,
    });
  }, [paymentMethod]);

  const handleCheckoutClick = () => {
    checkout();
  };

  const handleSubmitCreditCard = async () => {
    await chargeJournal(PAYMENT_METHOD.CARD);
  };

  const handleCheckIncludeVat = (checked) => {
    setIncludeVat(checked);
  };

  const { subTotal, vat, charge, discounts, grandTotal, wht } = detail;

  return (
    <div className="tendering-cart-content-summary">
      <div className="tendering-cart-content-summary-title">
        {TranslationWorkExchange("Order summary")}
      </div>
      <div className="tendering-cart-content-summary-detail">
        {step !== CART_STEP.INFO && (
          <div className="tendering-cart-content-summary-detail-items">
            {payments.map((selection) => {
              return <>Test</>;
            })}
          </div>
        )}
        <div className="tendering-cart-content-summary-detail-receipt">
          <div className="tendering-cart-content-summary-detail-receipt__row">
            <div>{TranslationWorkExchange("Subtotal")}</div>
            <div>
              ฿
              {(subTotal ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
          <div className="tendering-cart-content-summary-detail-receipt__row tendering-cart-content-summary-detail-receipt__row--small">
            <div>{TranslationShoppingCart("Vat (7%)")}</div>
            <div>
              +฿
              {(vat ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
          {wht ? (
            <div className="tendering-cart-content-summary-detail-receipt__row tendering-cart-content-summary-detail-receipt__row--small">
              <div>WHT (-3%)</div>
              <div>
                {" -฿"}
                {(wht ?? 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="tendering-cart-content-summary-detail-receipt__row tendering-cart-content-summary-detail-receipt__row--small">
            <div>
              {TranslationWorkExchange("Charge")}{" "}
              {paymentMethod == PAYMENT_METHOD.TRUEMONEY
                ? "(2.65%)"
                : paymentMethod == PAYMENT_METHOD.CARD
                ? "(3.65%)"
                : paymentMethod == PAYMENT_METHOD.QR
                ? "(1.65%)"
                : ""}
            </div>
            <div>
              {" +฿"}
              {(charge ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
          <div className="tendering-cart-content-summary-detail-receipt__separator" />
          <div className="tendering-cart-content-summary-detail-receipt__row">
            <div>{TranslationShoppingCart("Grand Total")}</div>
            <div style={{ fontWeight: "500" }}>
              ฿
              {(grandTotal ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </div>
        {payments.length > 0 && (
          <>
            {step === CART_STEP.INFO && (
              <div className="tendering-cart-content-summary-detail-footer">
                <Button
                  onClick={handleCheckoutClick}
                  label={TranslationWorkExchange("Check out")}
                  submitting={checkingOut}
                />
              </div>
            )}
            {step === CART_STEP.PAYMENT &&
              paymentMethod === PAYMENT_METHOD.CARD && (
                <div className="tendering-cart-content-summary-detail-footer">
                  <Button
                    onClick={handleSubmitCreditCard}
                    label={
                      charging
                        ? TranslationShoppingCart("Charging")
                        : TranslationShoppingCart("Pay")
                    }
                    disabled={!cardDetails}
                    submitting={charging}
                  />
                </div>
              )}
          </>
        )}
      </div>
    </div>
  );
};
